// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"fb91a52e","324":"4002d4d3","488":"996c6a8c","649":"d1be2e04","815":"64f02dfb"}[chunkId] + ".chunk.js";
};